const pagesIndividualAccountsEn = {
  headers: {
    actualRoleName: 'Role',
    app: 'App',
    category: 'Category',
    createdAt: 'Created',
    displayName: 'Display name',
    lastSignIn: 'Last sign-in',
    mfa: 'MFA',
    tenantName: 'Tenant'
  },
  mfa: {
    disabled: 'Off',
    enabled: 'On'
  },
  pageTitle: 'Accounts',
  tabs: {
    self: 'My accounts'
  }
};
export default pagesIndividualAccountsEn;